module.exports = __webpack_public_path__ + "static/media/sku219400762.9d1a7cb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/images/sku219400762.png
// module id = 516
// module chunks = 0